import { render, staticRenderFns } from "./CardShuffle.vue?vue&type=template&id=8a277522&scoped=true"
import script from "./CardShuffle.vue?vue&type=script&lang=js"
export * from "./CardShuffle.vue?vue&type=script&lang=js"
import style0 from "./CardShuffle.vue?vue&type=style&index=0&id=8a277522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a277522",
  null
  
)

export default component.exports